import http from "./httpService";
import config from "./config.json";
export const getProducts = () => {
  return http.get(`${config.vionna_api}/Products/GetAllProducts`);
};
